"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_hook_form_1 = require("react-hook-form");
var clsx_1 = __importDefault(require("clsx"));
var DictionaryItemsEditor_1 = __importDefault(require("../DictionaryItemsEditor"));
var Button_1 = __importStar(require("@/react-app/common/components/Button"));
var SingleSelect_1 = __importDefault(require("@/react-app/common/components/SingleSelect"));
function DictionaryForm(_a) {
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, save = _a.save, isEditing = _a.isEditing, dictionary = _a.dictionary;
    var t = (0, react_i18next_1.useTranslation)().t;
    var listTypes = [
        // List items can contain any combination of letters and numbers. For example: words, email addresses, ip addresses, phone numbers and regular expressions.
        { id: 'MIXED', text: t('AUTOMATION.LISTS.LIST_BUILDER.MIXED_LIST') },
        { id: 'CONFUSABLE', text: t('AUTOMATION.LISTS.LIST_BUILDER.CONFUSABLE_LIST') },
    ];
    var _b = __read((0, react_1.useState)([]), 2), items = _b[0], setItems = _b[1];
    var _c = __read((0, react_1.useState)(listTypes[0]), 2), kind = _c[0], setKind = _c[1];
    var _d = (0, react_hook_form_1.useForm)(), register = _d.register, handleSubmit = _d.handleSubmit, errors = _d.formState.errors, setValue = _d.setValue;
    (0, react_1.useEffect)(function () {
        if (dictionary) {
            setItems(dictionary.items);
            setValue('name', dictionary.name);
            setValue('description', dictionary.description || '');
        }
    }, [dictionary === null || dictionary === void 0 ? void 0 : dictionary.name]);
    var cancel = function () {
        angularJsDependencies.go('app.assignment.automation.dictionaries', { domain: domain });
    };
    var submit = function (formData) {
        var newDictionary = __assign(__assign({}, formData), { items: items });
        if (isEditing) {
            // kind should always be specified when editing a confusable
            if ((dictionary === null || dictionary === void 0 ? void 0 : dictionary.kind) === 'CONFUSABLE') {
                newDictionary.kind = dictionary === null || dictionary === void 0 ? void 0 : dictionary.kind;
            }
        }
        else {
            // kind needs to be specified on creation
            newDictionary.kind = kind.id;
        }
        save(newDictionary);
    };
    return (react_1.default.createElement("div", { className: "row dictionary-editor" },
        react_1.default.createElement("form", { name: "dictionaryForm", className: "simple-form col-md-12", noValidate: true },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('form-group', { 'has-error': errors.name }) },
                react_1.default.createElement("label", { className: "control-label", htmlFor: "dictionary-editor-name-input" }, t('AUTOMATION.LISTS.LIST_BUILDER.NAME_LABEL')),
                react_1.default.createElement("input", __assign({ className: "form-control", type: "text", id: "dictionary-editor-name-input", placeholder: t('AUTOMATION.LISTS.LIST_BUILDER.NAME_PLACEHOLDER'), disabled: isEditing, pattern: "^[A-Za-z0-9_]+$", required: true }, register('name', { required: true, pattern: /^[A-Za-z0-9_]+$/ }))),
                errors.name && react_1.default.createElement("p", { className: "help-block" }, t('AUTOMATION.LISTS.ERROR.NAME_REQUIRED'))),
            !isEditing && (react_1.default.createElement("div", { className: "form-group description" },
                react_1.default.createElement("label", { className: "control-label", htmlFor: "dictionary-editor-description-input" }, "List Type"),
                react_1.default.createElement(SingleSelect_1.default, { options: listTypes, value: kind, onChange: function (option) { return setKind(option); }, getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.text) || ''; }, getOptionValue: function (option) { return (option === null || option === void 0 ? void 0 : option.id) || ''; } }))),
            react_1.default.createElement("div", { className: "form-group description" },
                react_1.default.createElement("label", { className: "control-label", htmlFor: "dictionary-editor-description-input" }, t('AUTOMATION.LISTS.LIST_BUILDER.DESC_LABEL')),
                react_1.default.createElement("textarea", __assign({ className: "form-control", id: "dictionary-editor-description-input", placeholder: t('AUTOMATION.LISTS.LIST_BUILDER.DESC_PLACEHOLDER') }, register('description')))),
            react_1.default.createElement(DictionaryItemsEditor_1.default, { items: items, setItems: setItems }),
            react_1.default.createElement("div", { className: "form-group" },
                react_1.default.createElement("div", { className: "dictionary-editor-button-group" },
                    react_1.default.createElement(Button_1.SecondaryButton, { onClick: cancel, text: t('AUTOMATION.LISTS.BTN.CANCEL') }),
                    react_1.default.createElement(Button_1.default, { text: isEditing ? t('AUTOMATION.LISTS.BTN.SAVE_CHANGES') : t('AUTOMATION.LISTS.BTN.CREATE'), disabled: errors.name !== undefined || items.length === 0, onClick: handleSubmit(submit) }))))));
}
exports.default = DictionaryForm;
